module.exports = __webpack_public_path__ + "img/stt_shortland.a99cf1dc.svg";